<template>
  <div v-loading="loading">
    <el-table
      :data="collectList"
      border
      stripe
      style="width: 100%"
      header-row-class-name="header-row"
    >
      <el-table-column prop="collectName" align="center" label="序号">
        <template #default="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="collectName" align="center" label="标题">
      </el-table-column>
      <el-table-column prop="typename" align="center" label="类型">
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="收藏时间">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template #default="{row}">
          <el-button type="text" @click="handleDeleteCollect(row.refId)">
            取消收藏
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :current-page="collectPager.curPageNumber"
      :total="collectPager.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { getCollect, deleteCollect } from "@/api/user";
export default {
  data() {
    return {
      loading: true,
      collectList: [],
      collectPager: {
        pageSize: 10,
        curPageNumber: 1,
        total: 0
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.getCollectList();
      this.loading = false;
    },
    async handleDeleteCollect(id) {
      await deleteCollect({ refId: id });
      this.$message({
        message: "取消收藏",
        type: "success"
      });
      this.collectPager.curPageNumber = 1;
      this.getCollectList();
    },
    handleCurrentChange(val) {
      this.collectPager.curPageNumber = val;
      this.getCollectList();
    },
    async getCollectList() {
      await getCollect(this.collectPager)
        .then(response => {
          this.collectList = response.result.data.list;
          this.collectPager.total = response.result.count;
          this.collectPager.pageSize = response.result.pager.pageSize++;
          this.collectPager.curPageNumber = response.result.pager.curPageNumber;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
